// Duplicate component header removed; using existing component below
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, Validators } from '@angular/forms';
import { MatomoTracker } from 'ngx-matomo';
import { UntypedFormGroup } from '@angular/forms';
import { NzMessageService, NzMessageDataOptions } from 'ng-zorro-antd/message';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { catchError, forkJoin, map, Observable, throwError, of } from 'rxjs';
import { LayoutComponent } from 'src/app/layout/layout.component';

@Component({
  selector: 'app-wmsm-IDApplication',
  templateUrl: './wmsm-IDApplication.component.html',
  styleUrls: ['./wmsm-IDApplication.component.scss'],

})

export class WmsmIDApplicationComponent extends BaseComponent implements OnInit {
  SiteList: any;
  CompanyCodeList: any;
  loading: boolean = false;
  isDataLoaded = false;
  validateForm!: UntypedFormGroup;
  VendorGroupList: any;
  // 新增：客戶與來賓客戶表單
  customerForm!: UntypedFormGroup;
  guestCustomerForm!: UntypedFormGroup;
  guestVendorCodeOptions: Array<{ label: string; value: string }> = [];
  guestCustomerCodeOptions: Array<{ label: string; value: string }> = [];
  guestVendorCodeValue: string = '';
  guestVendorSearchCode: string = '';
  guestCustomerCodeSelectValue: string = '';
  vendorName: string = '';
  customerVendorName: string = '';
  private readonly guestVendorCodeOptionKey = 'value';
  activeTab: number = 0; // 0: Vendor, 1: Customer, 2: Guest Customer
  isSubmitting: boolean = false; // for Guest Vendor submit button

  constructor(
    private webApiService: WebApiService,
    private Environment: EnvironmentconfigService,
    private matomotracker: MatomoTracker,
    private messageService: NzMessageService,
    private LayoutComponent: LayoutComponent,
    private fb: FormBuilder) { super() }


  ngOnInit() {
    this.loading = true;
    this.isDataLoaded = false; // 确保在数据加载之前设置为false

    this.validateForm = this.fb.group({
      companyCode: [[], [Validators.required]],
      vendorCode: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [''],
      Site: ['', [Validators.required]],
      // 多選供應商群組使用陣列初始值
      vendorGroup: [[], [Validators.required]],
      vendorContact: [[], [Validators.required]]
    });

    // 一般客戶：無公司別 / 供應商群組
    this.customerForm = this.fb.group({
      customerCode: ['', [Validators.required]],
      customerContact: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: [''],
      Site: ['', [Validators.required]]
    });

    // 來賓客戶：暫定字段（後續再調整）
    this.guestCustomerForm = this.fb.group({
      guestCustomerCode: [''],
      customerName: ['', [Validators.required]],
      background: [''],
      customerAddress: [''],
      Site: [''],
      contactChineseName: [''],
      contactEnglishName: ['', [Validators.required]],
      contactMobile: [''],
      contactEmail: ['', [Validators.required, Validators.email]],
      companyPhone: [''],
      guestVendorCode: ['']
    });

    this.isDataLoaded = false; // 确保在数据加载之前设置为false

    // 假设你有获取这些列表的异步方法
    forkJoin({
      sites: this.getSiteList(),
      vendorGroups: this.getVendorGroup(),
    }).subscribe(
      results => {
        this.SiteList = results.sites;
        this.VendorGroupList = results.vendorGroups;
        // 加载两类下拉数据：来宾供应商与来宾回收商
        this.loadGuestVendorCodeOptions();
        this.loadGuestCustomerCodeOptions();
        this.loading = false;
        this.isDataLoaded = true; // 数据加载成功后设置为true
      },
      error => {
        this.loading = false;
        this.isDataLoaded = false; // 数据加载失败后仍设置为false
        this.messageService.error(error.message || 'An error occurred');
      }
    );

    this.LayoutComponent.geturl()
    this.matomotracker.trackPageView("一般性功能設置")
    this.matomotracker.trackEvent("一般性功能設置", "賬號申請", "Transation", 1);
  }

  submitForm(): void {
    if (this.validateForm.valid) {
      const site = this.validateForm.controls['Site'].value;
      this.loading = true;
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.registerVendor.url}`;
      // Backend expects RegisterVendorDto in request body (no data wrapper)
      const companyCodeList = this.validateForm.controls['companyCode'].value || [];
      const vendorGroup = this.validateForm.controls['vendorGroup'].value || [];
      const vendorCode = (this.validateForm.controls['vendorCode'].value || '').toString().trim();
      const vendorContactVal = this.validateForm.controls['vendorContact'].value || '';
      const person = Array.isArray(vendorContactVal) ? (vendorContactVal[0] || '').toString().trim() : (vendorContactVal || '').toString().trim();
      const phone = (this.validateForm.controls['phoneNumber'].value || '').toString().trim();
      const email = (this.validateForm.controls['email'].value || '').toString().trim();

      const dto = {
        VendorGroup: vendorGroup,
        CompanyCodeList: companyCodeList,
        VendorCode: vendorCode,
        Person: person,
        MobileNumber: email,
        Email: email,
        Telephone: phone,
        SiteName: site?.siteName,
        SiteNo: site?.siteNo,
      };

      this.webApiService.doPost(url, dto, false, true).subscribe(
        (res) => {
          this.loading = false;
          if (res.data != null && res.status == '200') {
            // 使用modal来显示成功消息，因为消息可能包含多行
            this.messageService.success(this.formatMessage(res.msg), {
              nzDuration: 5000,  // 5秒后自动消失
              nzStyle: {
                width: '500px',
                whiteSpace: 'pre-line'
              }
            } as NzMessageDataOptions);
            this.ngOnInit();
          } else {
            // 使用modal来显示错误消息
            this.messageService.error(this.formatMessage(res.msg), {
              nzDuration: 8000,  // 8秒后自动消失
              nzStyle: {
                width: '500px',
                whiteSpace: 'pre-line'
              }
            } as NzMessageDataOptions);
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.error(this.formatMessage(error.msg), {
            nzDuration: 0,
            nzStyle: {
              width: '500px',
              whiteSpace: 'pre-line'
            }
          } as NzMessageDataOptions);
        }
      );
    } else {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  private loadGuestVendorCodeOptions(): void {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestVendorAccounts.url}`;
    const request = {
      pageIndex: 1,
      pageSize: 1000,
      data: {}
    };

    this.webApiService.doPost(url, request).subscribe(
      (res: any) => {
        const rawList: any[] = Array.isArray(res?.data) ? res.data : [];
        const options: Array<{ label: string; value: string }> = rawList
          .map((item: any) => {
            const value = `${item?.guestVendorCode || item?.supplierId || item?.guestVendorId || item?.vendorCode || ''}`.trim();
            return value ? { label: value, value } : null;
          })
          .filter((item: { label: string; value: string } | null): item is { label: string; value: string } => !!item);

        this.guestVendorCodeOptions = Array.from(new Map(options.map((item: { label: string; value: string }) => [item.value, item])).values());
      },
      (error) => {
        this.guestVendorCodeOptions = [];
        console.error('Load guest customer code options failed', error);
      }
    );
  }

  private loadGuestCustomerCodeOptions(): void {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestCustomerAccounts.url}`;
    const request = {
      pageIndex: 1,
      pageSize: 1000,
      data: {}
    };

    this.webApiService.doPost(url, request).subscribe(
      (res: any) => {
        const rawList: any[] = Array.isArray(res?.data) ? res.data : [];
        const options: Array<{ label: string; value: string }> = rawList
          .map((item: any) => {
            const value = `${item?.guestCustomerCode || item?.customerCode || item?.supplierId || ''}`.trim();
            return value ? { label: value, value } : null;
          })
          .filter((item: { label: string; value: string } | null): item is { label: string; value: string } => !!item);

        this.guestCustomerCodeOptions = Array.from(new Map(options.map((item: { label: string; value: string }) => [item.value, item])).values());
      },
      (error) => {
        this.guestCustomerCodeOptions = [];
        console.error('Load guest customer code options failed', error);
      }
    );
  }

  submitCustomerForm(): void {
    if (this.customerForm.valid) {

      const site = this.customerForm.controls['Site'].value;
      this.loading = true;
      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.registerCustomer.url}`;
      // Backend expects AddCustomerContactDto directly
      const dto = {
        CustomerCode: (this.customerForm.controls['customerCode'].value || '').toString().trim(),
        Person: (this.customerForm.controls['customerContact'].value || '').toString().trim(),
        Telephone: '',
        MobileNumber: (this.customerForm.controls['phoneNumber'].value || '').toString().trim(),
        Email: (this.customerForm.controls['email'].value || '').toString().trim(),
        SiteName: site?.siteName || '',
        SiteNo: site?.siteNo || ''
      };
      this.webApiService.doPost(url, dto, false, true).subscribe(
        (res) => {
          this.loading = false;
          if (res.data != null && res.status == '200') {
            this.messageService.success(this.formatMessage(res.msg), {
              nzDuration: 5000,
              nzStyle: { width: '500px', whiteSpace: 'pre-line' }
            } as NzMessageDataOptions);
            this.customerForm.reset();
            this.customerVendorName = '';
          } else {
            this.messageService.error(this.formatMessage(res.msg), {
              nzDuration: 8000,
              nzStyle: { width: '500px', whiteSpace: 'pre-line' }
            } as NzMessageDataOptions);
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.error(this.formatMessage(error.msg), {
            nzDuration: 0,
            nzStyle: { width: '500px', whiteSpace: 'pre-line' }
          } as NzMessageDataOptions);
        }
      );
    } else {
      Object.values(this.customerForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  lookupVendorName(): void {
    const vendorCode = (this.validateForm.controls['vendorCode'].value || '').toString().trim();
    this.vendorName = '';
    if (!vendorCode) return;

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetVendorAccounts.url}`;
    const request = { pageIndex: 1, pageSize: 10, data: { vendorCode } };
    this.webApiService.doPost(url, request).subscribe(
      (res: any) => {
        const target = Array.isArray(res?.data) ? res.data[0] : res?.data;
        this.vendorName = (target?.vendorName || target?.supplierName || '').toString().trim();
      },
      () => {
        this.vendorName = '';
      }
    );
  }

  lookupCustomerVendorName(): void {
    const customerCode = (this.customerForm.controls['customerCode'].value || '').toString().trim();
    this.customerVendorName = '';
    if (!customerCode) return;

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetCustomerAccounts.url}`;
    const request = { pageIndex: 1, pageSize: 10, data: { customerCode } };
    this.webApiService.doPost(url, request).subscribe(
      (res: any) => {
        const target = Array.isArray(res?.data) ? res.data[0] : res?.data;
        this.customerVendorName = (target?.vendorName || target?.supplierName || target?.customerName || '').toString().trim();
      },
      () => {
        this.customerVendorName = '';
      }
    );
  }

  submitGuestCustomerForm(): void {
    if (this.guestCustomerForm.valid) {
      const site = this.guestCustomerForm.controls['Site'].value;
      this.loading = true;

      const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.registerGuestCustomer.url}`;
      // Backend expects AddGuestCustomerContactDto directly; normalize values
      const guestCustomerCode = (this.guestCustomerForm.controls['guestCustomerCode'].value || '').toString().trim();
      // if (!guestCustomerCode) {
      //   this.loading = false;
      //   this.messageService.error('GuestCustomerCode 为必填');
      //   return;
      // }
      const contactEmail = (this.guestCustomerForm.controls['contactEmail'].value || '').toString().trim();
      const contactMobile = (this.guestCustomerForm.controls['contactMobile'].value || '').toString().trim();
      const guestVendorCode = (this.guestCustomerForm.controls['guestVendorCode'].value || '').toString().trim();
      const dto = {
        GuestCustomerCode: guestCustomerCode,
        CustomerName: (this.guestCustomerForm.controls['customerName'].value || '').toString().trim(),
        CustomerAddress: (this.guestCustomerForm.controls['customerAddress'].value || '').toString().trim(),
        Background: (this.guestCustomerForm.controls['background'].value || '').toString().trim(),
        SiteNo: site?.siteNo || '',
        CompanyCode: '',
        ContactEmail: contactEmail,
        ContactMobile: contactMobile,
        ContactChineseName: (this.guestCustomerForm.controls['contactChineseName'].value || '').toString().trim(),
        ContactEnglishName: (this.guestCustomerForm.controls['contactEnglishName'].value || '').toString().trim(),
        ContactCompanyPhone: (this.guestCustomerForm.controls['companyPhone'].value || '').toString().trim(),
        GuestVendorCode: guestVendorCode,
      };
      if (!dto.ContactEmail) {
        this.loading = false;
        this.messageService.error('ContactEmail为必填');
        return;
      }
      if (dto.Background && dto.Background.length > 1) {
        this.loading = false;
        this.messageService.error('背景字段' + '应该 小于等于1个字符或文字');
        return;
      }
      this.webApiService.doPost(url, dto, false, true).subscribe(
        (res) => {
          this.loading = false;
          if (res.data != null && res.status == '200') {
            this.messageService.success(this.formatMessage(res.msg), {
              nzDuration: 5000,
              nzStyle: { width: '500px', whiteSpace: 'pre-line' }
            } as NzMessageDataOptions);
            this.guestCustomerForm.reset();
          } else {
            this.messageService.error(this.formatMessage(res.msg), {
              nzDuration: 8000,
              nzStyle: { width: '500px', whiteSpace: 'pre-line' }
            } as NzMessageDataOptions);
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.error(this.formatMessage(error.msg), {
            nzDuration: 0,
            nzStyle: { width: '500px', whiteSpace: 'pre-line' }
          } as NzMessageDataOptions);
        }
      );
    } else {
      Object.values(this.guestCustomerForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  searchGuestVendorByCode(): void {
    const guestVendorCode = (this.guestVendorSearchCode || '').toString().trim();
    if (!guestVendorCode) {
      this.messageService.warning('請輸入來賓供應商代碼');
      return;
    }

    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestVendorAccounts.url}`;
    const request = {
      pageIndex: 1,
      pageSize: 10,
      data: {
        vendorcode: guestVendorCode
      }
    };

    this.webApiService.doPost(url, request).subscribe(
      (res: any) => {
        this.loading = false;
        const target = (res?.data || []).find((item: any) => {
          const currentCode = (item.guestVendorCode || item.supplierId || '').toString().trim().toUpperCase();
          return currentCode === guestVendorCode.toUpperCase();
        });

        if (!target) {
          this.messageService.warning('查無對應的來賓供應商資料');
          this.clearGuestVendorInputs();
          return;
        }

        const setInputValue = (id: string, value: any) => {
          const el = document.getElementById(id) as HTMLInputElement | null;
          if (el) {
            el.value = value != null ? String(value) : '';
          }
        };

        setInputValue('vendorName', target.supplierName || target.vendorName || '');
        setInputValue('vendorAddress', target.customerAddress || target.vendorAddress || '');
        setInputValue('background', target.background || '');
        setInputValue('contactEmail', target.contactEmail || target.vendorMail || target.account || '');
        setInputValue('contactMobile', target.contactMobile || target.vendorContact || '');
        setInputValue('contactChineseName', target.contactChineseName || '');
        setInputValue('contactEnglishName', target.contactEnglishName || '');
        setInputValue('contactCompanyPhone', target.companyPhone || '');
        this.guestVendorCodeValue = (target.guestVendorCode || target.supplierId || target.guestVendorId || '').toString().trim();

        // 如果下拉没有该选项，则插入显示该条数据到下拉
        if (this.guestVendorCodeValue) {
          const exists = this.guestVendorCodeOptions.some(o => o.value === this.guestVendorCodeValue);
          if (!exists) {
            this.guestVendorCodeOptions = [{ label: this.guestVendorCodeValue, value: this.guestVendorCodeValue }, ...this.guestVendorCodeOptions];
          }
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.error(error?.msg || '查詢來賓供應商失敗');
      }
    );
  }

  // 搜尋不到時清空來賓供應商欄位，避免殘留第一次搜尋的資料
  private clearGuestVendorInputs(): void {
    const ids = [
      'vendorName',
      'vendorAddress',
      'background',
      'contactEmail',
      'contactMobile',
      'contactChineseName',
      'contactEnglishName',
      'contactCompanyPhone'
    ];
    ids.forEach(id => {
      const el = document.getElementById(id) as HTMLInputElement | null;
      if (el) {
        el.value = '';
      }
    });
    this.guestVendorCodeValue = '';
    this.guestVendorSearchCode = '';
  }

  // 通过给定 code 调用 searchGuestVendorByCode 填充表单，并保留当前选中的代碼
  private searchGuestVendorByCodeByValue(code: string): void {
    if (!code) return;
    this.guestVendorSearchCode = code;
    this.searchGuestVendorByCode();
  }

  // 下拉选择时触发：复用搜索逻辑填充其它字段
  onGuestVendorCodeSelect(value: string): void {
    if (!value) return;
    this.searchGuestVendorByCodeByValue(value);
  }

  // 在 guestCustomer 表单中选择 GuestVendorCode 时，也用同样搜索方法去填充数据
  // 優先使用本次輸入/傳入的代碼，避免第二次搜尋仍使用上次的下拉值（selectedValue）
  resolveGuestCustomerSearchCode(code?: string): string {
    const selectedValue = (this.guestCustomerCodeSelectValue || '').toString().trim();
    const formValue = (this.guestCustomerForm.controls['guestCustomerCode'].value || '').toString().trim();
    const fallback = (code || '').toString().trim();
    return fallback || formValue || selectedValue;
  }

  onGuestCustomerCodeSelect(value: string): void {
    if (!value) {
      this.guestCustomerCodeSelectValue = '';
      this.guestCustomerForm.patchValue({ guestVendorCode: '', guestCustomerCode: '' }, { emitEvent: false });
      return;
    }
    this.guestCustomerCodeSelectValue = value;
    this.guestCustomerForm.patchValue({ guestVendorCode: value, guestCustomerCode: value }, { emitEvent: false });
    this.searchGuestCustomerByCodeByValue(value);
  }

  private searchGuestCustomerByCodeByValue(code: string): void {
    if (!code) return;
    const codeControl = this.guestCustomerForm.get('guestCustomerCode');
    if (codeControl) {
      codeControl.setValue(code, { emitEvent: false });
    }
    this.searchGuestCustomerByCode(code);
  }

  searchGuestCustomerByCode(code?: string): void {
    const guestCustomerCode = this.resolveGuestCustomerSearchCode(code);
    if (!guestCustomerCode) {
      this.messageService.warning('請輸入來賓代碼');
      return;
    }

    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetGuestCustomerAccounts.url}`;
    const request = {
      pageIndex: 1,
      pageSize: 10,
      data: {
        customerCode: guestCustomerCode
      }
    };

    this.webApiService.doPost(url, request).subscribe(
      (res: any) => {
        this.loading = false;
        const target = (res?.data || []).find((item: any) => {
          const currentCode = (item.guestCustomerCode || item.customerCode || item.supplierId || '').toString().trim().toUpperCase();
          return currentCode === guestCustomerCode.toUpperCase();
        });

        if (!target) {
          this.messageService.warning('查無對應的來賓回收商資料');
          this.clearGuestCustomerFields();
          return;
        }

        const resolvedCode = (target.guestCustomerCode || target.customerCode || target.supplierId || '').toString().trim();
        this.guestCustomerForm.patchValue({
          guestCustomerCode: resolvedCode || this.resolveGuestCustomerSearchCode(),
          guestVendorCode: target.guestVendorCode || target.supplierId || target.guestCustomerCode || this.guestCustomerCodeSelectValue || this.resolveGuestCustomerSearchCode(),
          customerName: target.supplierName || target.customerName || '',
          background: target.background || '',
          customerAddress: target.customerAddress || target.vendorAddress || '',
          contactChineseName: target.contactChineseName || '',
          contactEnglishName: target.contactEnglishName || '',
          contactMobile: target.contactMobile || target.vendorContact || '',
          contactEmail: target.contactEmail || target.vendorMail || target.account || '',
          companyPhone: target.companyPhone || ''
        });
        if (resolvedCode) {
          this.guestCustomerCodeSelectValue = resolvedCode;
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.error(error?.msg || '查詢來賓回收商失敗');
      }
    );
  }



  // 搜尋不到時清空來賓客戶/回收商欄位，避免殘留第一次搜尋的資料
  private clearGuestCustomerFields(): void {
    this.guestCustomerForm.patchValue({
      guestVendorCode: '',
      customerName: '',
      background: '',
      customerAddress: '',
      contactChineseName: '',
      contactEnglishName: '',
      contactMobile: '',
      contactEmail: '',
      companyPhone: ''
    });
    this.guestCustomerCodeSelectValue = '';
  }


  // 添加一个格式化消息的辅助方法
  private formatMessage(message: string): string {

    if (!message) return '';

    // 将 \n 转换为 HTML 的 <br> 标签
    return message.replace(/\n/g, '<br>');

    // debugger
    // if (!message) return '';

    // // 如果消息中包含换行符，直接返回
    // if (message.includes('\n')) return message;

    // // 将点号后面的内容转换为新行（针对旧格式的消息）
    // return message.replace(/\. /g, '.\n');
  }

  getVendorGroup(): Observable<any[]> {
    // 靜態返回供應商群組：只需要 WZS 和 WHQ
    return of([
      { typeName: 'WZS', type: 'WZS' },
      { typeName: 'WHQ', type: 'WHQ' }
    ]);
  }


  getSiteList(): Observable<any[]> {
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSiteList.url}`;
    return this.webApiService.doGet(url).pipe(
      map((res: any) => {
        if (res.status === '200') {
          return res.data;
        } else {
          throw new Error('Non-200 status code');
        }
      }),
      catchError((error) => {
        this.messageService.error(error.message || 'An error occurred');
        return throwError(error);
      })
    );
  }

  getCompanyCodeList(Site: any) {
    var siteNo = Site.siteNo;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.getCompanyDtoBySiteNo.url}` + '?SiteNo=' + siteNo;
    const params = {
    };
    this.webApiService.doGet(url).subscribe(
      (res) => {
        if (res.status == '200') {
          this.CompanyCodeList = res.data;
        }
        else {
          throw new Error('Non-200 status code');
        }

      },
      (error) => {
        this.messageService.error(error.message || 'An error occurred');
      }
    );
  }



  // Submit handler for Guest Vendor inline form
  submitGuestVendor(): void {
    if (this.isSubmitting) return;

    // Grab input values by element id (inline form uses plain inputs)
    const getVal = (id: string) => (document.getElementById(id) as HTMLInputElement)?.value?.trim() || '';
    const vendorName = getVal('vendorName');
    const vendorAddress = getVal('vendorAddress');
    const background = getVal('background');
    const contactEmail = getVal('contactEmail');
    const contactMobile = getVal('contactMobile');
    const contactChineseName = getVal('contactChineseName');
    const contactEnglishName = getVal('contactEnglishName');
    const contactCompanyPhone = getVal('contactCompanyPhone');
    const guestVendorCode = this.guestVendorCodeValue || '';
    // Basic validations similar to wmsm-GuestVendor requirements
    if (!vendorName) { this.messageService.error('Vendor Name is required'); return; }
    if (!contactEmail) { this.messageService.error('Contact Email is required'); return; }
    // if (!contactMobile) { this.messageService.error('Contact Mobile is required'); return; }
    if (!contactEnglishName) { this.messageService.error('Contact English Name is required'); return; }
    // Background tip: align with existing rule (limit length<=1 character as per original component)
    if (background && background.length > 1) {
      this.messageService.error('Background ' + 'length should be 1 or less');
      return;
    }

    this.isSubmitting = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.registerGuestVendor.url}`;
    // Backend expects CreateGuestVendorDto directly
    const dto = {
      VendorName: vendorName,
      VendorAddress: vendorAddress,
      Background: background,
      SiteNo: '',
      SiteName: 'ALL',

      CompanyCode: '',
      ContactEmail: contactEmail,
      ContactMobile: contactMobile,
      ContactPosition: '',
      ContactChineseName: contactChineseName,
      ContactEnglishName: contactEnglishName,
      ContactCompanyPhone: contactCompanyPhone,
      GuestVendorCode: guestVendorCode,
    };

    this.webApiService.doPost(url, dto, false, true).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.messageService.success(res.msg + '新增成功');
        } else {
          this.messageService.error(res.msg || 'Submit failed');
        }
        this.isSubmitting = false;
      },
      (error) => {
        this.messageService.error(error?.msg || 'Server error');
        this.isSubmitting = false;
      }
    );
  }
}
